/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '#utils/UNSAFE_classNames';
import { LineProps } from '#utils/UNSAFE_visTypes/common';
import { styles } from './themes/SvgShapesStyles.css';

export const Line = ({ lineWidth = 3, lineStyle = 'solid', color, lineLength }: LineProps) => {
  const isNotSolid = lineStyle != 'solid';
  const lineExtension = lineLength != undefined ? lineLength : 0;
  const { lineBaseStyle, lineDottedStyle, lineDashedStyle } = styles;
  return (
    <line
      x1={0 - lineExtension}
      y1={50}
      x2={100 + lineExtension}
      y2={50}
      stroke={color}
      strokeWidth={lineWidth}
      class={classNames([
        lineBaseStyle,
        isNotSolid ? (lineStyle === 'dotted' ? lineDottedStyle : lineDashedStyle) : ''
      ])}
    />
  );
};
